import { render, staticRenderFns } from "./headBar.vue?vue&type=template&id=2330c950&scoped=true"
import script from "./headBar.vue?vue&type=script&lang=js"
export * from "./headBar.vue?vue&type=script&lang=js"
import style0 from "./headBar.vue?vue&type=style&index=0&id=2330c950&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330c950",
  null
  
)

export default component.exports